import { fromBrowserPath } from "./hamiPaths";
/**
 * مسیر /stories/:id برای مشاهده بدون اجبار مودال ورود (لینک از جستجو و غیره).
 * /stories/create و سایر مسیرها تحت همان قوانین احراز هویت قبلی هستند.
 */
export function isPublicStoryViewerPath(pathname) {
  const path = String(pathname || "");
  if (path === "/stories/create") return false;
  return /^\/stories\/[^/]+$/.test(path);
}

/**
 * روی صفحه viewer استوری، 401 مربوط به API استوری نباید مودال ورود را باز کند.
 */
export function isPublicStoryApiRequest(url, method = "GET") {
  if (!isPublicStoryViewerPath(
    typeof window !== "undefined" ? fromBrowserPath(window.location.pathname) : ""
  )) {
    return false;
  }

  try {
    const req = typeof url === "string" ? new URL(url) : url;
    const m = String(method || "GET").toUpperCase();
    const storiesSegment = "/stories";
    const idx = req.pathname.indexOf(storiesSegment);
    if (idx === -1) return false;

    const rest = req.pathname.slice(idx + storiesSegment.length);
    if (rest === "" || rest === "/") {
      return m === "GET";
    }
    if (/^\/\d+\/?$/.test(rest)) {
      return m === "GET";
    }
    if (/^\/\d+\/view\/?$/.test(rest)) {
      return m === "POST";
    }
    return false;
  } catch {
    return false;
  }
}
